import { Button, Divider, Header, Text } from '@wework/dieter-ui'
import { withFloorMap, withManager } from '@wework/react-floormap'
import _ from 'lodash'
import withFeatures from '../../hoc/withFeatures'
import compose from '../../utils/compose'
import React, { useState, useEffect } from 'react'
import Row from '../Common/Row'
import { withSnackbar } from '../../hoc/SnackBarProvider'
import { useSidebar } from '../../hoc/withSidebar'
import withEventEmitter from '../../hoc/withEventEmitter'
import CloseIcon from '../../assets/images/CloseIcon.svg'
import notLinkedIcon from '../../assets/icons/notLinkedIcon.png'
import {
  CommonAreasIcon,
  NooksIcon,
  OfficeBorderedIcon,
  RestRoomBorderedIcon,
  KitchenBorderedIcon,
  PrinterAlcoveBorderedIcon,
  PhoneBoothBorderedIcon,
  ConferenceRoomBorderedIcon,
  StandartOfficeBorderedIcon,
  CommunityBarBorderedIcon,
} from '../Icons'
import IMTheme from '../../style/IMTheme'
import { Loader } from 'semantic-ui-react'

const spaceTypesData = [
  {
    notLinkedNumber: 0,
    totalNumber: 3,
    icon: <CommunityBarBorderedIcon />,
    title: 'Community Bar',
  },
  {
    notLinkedNumber: 3,
    totalNumber: 10,
    icon: <OfficeBorderedIcon />,
    title: 'Standart Offices',
  },
  {
    notLinkedNumber: 1,
    totalNumber: 3,
    icon: <ConferenceRoomBorderedIcon />,
    title: 'Conference Rooms',
  },
  {
    notLinkedNumber: 0,
    totalNumber: 5,
    icon: <PhoneBoothBorderedIcon />,
    title: 'Phone Booths',
  },
  {
    notLinkedNumber: 0,
    totalNumber: 4,
    icon: <PrinterAlcoveBorderedIcon />,
    title: 'Printer Alcoves',
  },
  {
    notLinkedNumber: 0,
    totalNumber: 3,
    icon: <KitchenBorderedIcon />,
    title: 'Kitchen',
  },
  {
    notLinkedNumber: 0,
    totalNumber: 2,
    icon: <CommonAreasIcon />,
    title: 'Common Areas',
  },
  { notLinkedNumber: 0, totalNumber: 1, icon: <NooksIcon />, title: 'Nooks' },
  {
    notLinkedNumber: 0,
    totalNumber: 1,
    icon: <RestRoomBorderedIcon />,
    title: 'Restrooms',
  },
]

function BuildingInfoSpaces({ floorMap, manager, snackBars }) {
  const { closeSideBar, openSideBar } = useSidebar()
  const { currentBuilding, currentFloor } = floorMap
  const [data, setData] = useState<any>([])
  const floorName = _.get(currentFloor, 'name')
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    setLoading(true)
    const fetchUnlinkedSpaces = async () => {
      try {
        const client = manager.getClient()
        const response = await client.get(`/floors/${currentFloor?.uuid}`, {
          'extra_fields[floor]': 'room_count_split',
        })
        const { data, meta } = response
        if (!meta.success) {
          throw new Error(meta.message)
        }
        setLoading(false)
        setData(data.attributes.room_count_split)
      } catch (error) {
        setLoading(false)
        snackBars.addAlert({
          text: `There was a problem getting info, ${error}`,
          variant: 'error',
        })
      }
    }
    fetchUnlinkedSpaces()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [manager])

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Row>
          <Header as="h3" style={{ margin: 0 }}>
            Spaces
          </Header>
          <Button
            basic
            onClick={() => closeSideBar()}
            icon={
              <div style={{ width: 18, height: 18 }}>
                <CloseIcon />
              </div>
            }
            style={{
              margin: 0,
            }}
          />
        </Row>
        <Text style={{ marginTop: 28 }} size="huge">
          {floorName}
        </Text>
        <Divider light style={{ margin: '24px 0px 0px 0px' }} />
        {loading ? (
          <div
            style={{
              height: 150,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Loader active style={{ position: 'fixed' }} size="small" />
            <span style={{ marginTop: 12 }}>Loading...</span>
          </div>
        ) : (
          <>
            {data &&
              data.length > 0 &&
              data.map(({ type, unlinked, linked }) => (
                <div key={type}>
                  <Row style={{ marginTop: 20 }} justify="flex-start">
                    {unlinked.length > 0 ? (
                      <Text
                        style={{ textTransform: 'capitalize' }}
                        size="small"
                      >
                        {`${unlinked.length} ${type.toLowerCase()}`}
                      </Text>
                    ) : (
                      <Text
                        size="small"
                        style={{
                          cursor: 'pointer',
                          textTransform: 'capitalize',
                        }}
                      >
                        {`${linked.length} ${type.toLowerCase()}`}
                      </Text>
                    )}
                  </Row>
                  {unlinked && unlinked.length > 0 && (
                    <Row style={{ margin: 0 }} justify="flex-start">
                      <Text
                        primary
                        style={{
                          cursor: 'pointer',
                          fontSize: IMTheme.fontSizes[1],
                        }}
                      >
                        {`${unlinked.length} not linked`}
                      </Text>
                      <img
                        src={notLinkedIcon}
                        style={{ width: 12, height: 12, marginLeft: 2 }}
                        alt={'notLinkedIcon'}
                      />
                    </Row>
                  )}
                </div>
              ))}
          </>
        )}
      </div>
    </>
  )
}

export default compose(
  withFloorMap(),
  withManager()
)(withSnackbar(BuildingInfoSpaces))
